import { Modal, Table, Tabs } from "antd";
import { PERMISSIONS, useAuthorization } from "features/permissions";
import PacketedDebtorsTable from "./packetedDebtorsTable";
import PacketedAccountsTable from "./packetedAccountsTable";
import PacketedLawsuitsTable from "./packetedLawsuitsTable";

export default function PacketedCollectionRecordsModal({ open, onCancel, packetId }) {
  // Debtor.get permissions check for all 3 tabs
  const { data: isDebtorGetAuthorized } = useAuthorization(PERMISSIONS.DEBTOR__GET);
  const tabs = [
    {
      key: "packetedDebtors",
      label: "Packeted Debtors",
      children: isDebtorGetAuthorized ? <PacketedDebtorsTable packetId={packetId} /> : <Table />,
    },
    {
      key: "packetedAccounts",
      label: "Packeted Accounts",
      children: isDebtorGetAuthorized ? <PacketedAccountsTable packetId={packetId} /> : <Table />,
    },
    {
      key: "packetedLawsuits",
      label: "Packeted Lawsuits",
      children: isDebtorGetAuthorized ? <PacketedLawsuitsTable packetId={packetId} /> : <Table />,
    },
  ];

  return (
    <Modal
      maskClosable={false}
      width={1100}
      footer={null}
      title="Packeted Collection Records"
      open={open}
      onCancel={onCancel}
    >
      <Tabs items={tabs} />
    </Modal>
  );
}
